import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import Menu from "@material-ui/core/Menu";

import { Link, Redirect } from "react-router-dom";
import {
  AccountCircle,
  Book,
  HelpOutlineRounded,
  OpenInNewTwoTone,
  PlaylistAdd,
} from "@material-ui/icons";
import { Button, MenuItem } from "@material-ui/core";
import App from "../../App";
import AdminRouteConfig from "./adminRoutes/AdminRouteConfig";
import UsersList1 from "./users/UsersList";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function AdminHeader() {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [login, setLogin] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    setAnchorEl(null);
    sessionStorage.removeItem("loggedIn");
    sessionStorage.clear();
    window.location.reload();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            PLM Portal
          </Typography>

          <div style={{ marginLeft: "80%", width: "5%" }}>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle fontSize="large" style={{ marginLeft: "40%" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={open1}
              onClose={handleClose}
            >
              <AccountCircle fontSize="large" style={{ marginLeft: "40%" }} />

              <MenuItem onClick={handleClose}>
                <Typography>{sessionStorage.getItem("userName")}</Typography>
                <hr />
              </MenuItem>
              <MenuItem>
                <Typography>{sessionStorage.getItem("emailId")}</Typography>
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          <Link to="/admin/" style={{ textDecoration: "none" }}>
            <ListItem button>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText>Questions</ListItemText>
            </ListItem>
          </Link>
          <Link to="/admin/installation" style={{ textDecoration: "none" }}>
            <ListItem button>
              <ListItemIcon>
                <PlaylistAdd />
              </ListItemIcon>
              <ListItemText>Add Installation Guides</ListItemText>
            </ListItem>
          </Link>
          <Link to="/admin/users" style={{ textDecoration: "none" }}>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Users</ListItemText>
            </ListItem>
          </Link>
          <Link to="/admin/task" style={{ textDecoration: "none" }}>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Tasks</ListItemText>
            </ListItem>
          </Link>
          <Link to="/admin/projects" style={{ textDecoration: "none" }}>
            <ListItem button>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Projects</ListItemText>
            </ListItem>
          </Link>

          <ListItem onClick={handleLogout} button>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </ListItem>
        </List>
        <Divider />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
        <AdminRouteConfig />
      </main>
    </div>
  );
}
